export default __webpack_public_path__ + "static/media/music_popup_one.42a131e7.png";